import TenCommandEmbed from "../images/TenCommandEmbed";
import TenC from "../Thumbs/TenC60.jpg";

const TenCommandments = {
    objectName: 'TenCommandments',
    firstName: 'Ten',
    lastName: 'Commandments',
    id: 'Exd20TenCom',
    image: TenCommandEmbed,
    thumbImg: TenC,
    quotes: [
    {
        tabHeading: `Exodus - Ten Commandments`,
        metaDescription: `And God spoke all these words: I am the Lord your God, who brought you out of Egypt, out of the land of slavery.`,
        keywords: ["TrueLibertyNorth", ],
        title: 'Exodus 20 - Jewish Numbering',
        id: 'Exd20TenComTxt',
        headTitle: `Exodus - Ten Commandments`,
        headDescription: `And God spoke all these words: I am the Lord your God, who brought you out of Egypt, out of the land of slavery.`,
        content: [
              {normal: `1 `, bold2: `And God spoke all these words:`},
              {bold: `I. `, normal: `2 “I am the LORD your God, who brought you out of Egypt, out of the land of slavery.`},
              {bold: `II. `, normal: `3 “You shall have no other gods before me. 4 “You shall not make for yourself an image in the form of anything in heaven above or on the earth 
            beneath or in the waters below. 5 You shall not bow down to them or worship them; for I, the LORD your God, am a jealous God, punishing the children for 
            the sin of the parents to the third and fourth generation of those who hate me, 6 but showing love to a thousand generations of those who love me and keep 
            my commandments.`},
              {bold: `III. `, normal: `7 “You shall not misuse the name of the LORD your God, for the LORD will not hold anyone guiltless who misuses his name.`},
              {bold: `IV. `, normal: `8 “Remember the Sabbath day by keeping it holy. 9 Six days you shall labor and do all your work, 10 but the seventh day is a sabbath to the 
            LORD your God. On it you shall not do any work, neither you, nor your son or daughter, nor your male or female servant, nor your animals, nor any foreigner residing 
            in your towns. 11 For in six days the LORD made the heavens and the earth, the sea, and all that is in them, but he rested on the seventh day. Therefore the LORD 
            blessed the Sabbath day and made it holy.`},
              {bold: `V. `, normal: `12 “Honor your father and your mother, so that you may live long in the land the LORD your God is giving you.`},
              {bold: `VI. `, normal: `13 “You shall not murder.`},
              {bold: `VII. `, normal: `14 “You shall not commit adultery.`},
              {bold: `VIII. `, normal: `15 “You shall not steal.`},
              {bold: `IX. `, normal: `16 “You shall not give false testimony against your neighbor.`},
              {bold: `X. `, normal: `17 “You shall not covet your neighbor’s house. You shall not covet your neighbor’s wife, or his male or female servant, his ox or donkey, or 
            anything that belongs to your neighbor.”`},
        ],
        considerations: [
            {
                name: '',
                title: 'Matthew 22:34-40',
                date: '',
                content: [`Hearing that Jesus had silenced the Sadducees, the Pharisees got together. One of them, an expert in the law, tested him with this question: 
              “Teacher, which is the greatest commandment in the Law?” Jesus replied: “ ‘Love the Lord your God with all your heart and with all your soul and with all your 
              mind.’ This is the first and greatest commandment. And the second is like it: ‘Love your neighbor as yourself.’ All the Law and the Prophets hang on these 
              two commandments.”`]
            }
        ]
    }    
]};

export default TenCommandments;